import React from "react";
import { Tab, Nav } from "react-bootstrap";
import { aboutTabItem } from "../../data";
import { AboutTabItem,
  CompanyStory,
  AboutOurFounder,
  ContactUs,
  MissionVission  } from "./sub-component";
const AboutTab = () => {
  return (
    <div className="about__tab">
      <Tab.Container defaultActiveKey="companyStory">
        <div className="about__filter">
          <Nav variant="pills" className="about__nav justify-content-center">
            {aboutTabItem.map((val, index) => {
              return (
                <AboutTabItem
                  key={index}
                  title={val.title}
                  eventKey={val.eventKey}
                />
              );
            })}
          </Nav>
        </div>
        <Tab.Content>
          <Tab.Pane eventKey="companyStory">
            <CompanyStory />
          </Tab.Pane>
          <Tab.Pane eventKey="aboutOurFounder">
            <AboutOurFounder />
          </Tab.Pane>
          <Tab.Pane eventKey="missionVision">
            <MissionVission />
          </Tab.Pane>
          <Tab.Pane eventKey="contactUs">
            <ContactUs />
          </Tab.Pane>
         
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

export default AboutTab;
